import React from 'react';
import ReactDOM from 'react-dom/client';
import { Location } from '@reach/router';
import { PrivateRoute, Layout } from './src/components';
import { NetlifyIdentityProvider } from './src/context/NetlifyIdentityContext';

export const wrapPageElement = ({ props }) => {
  const { component, page } = props.pageResources;
  const PageComponent = component.default;
  const pageIsPrivate = page.path.includes('/admin/');
  return (
    <Layout {...props}>
      {pageIsPrivate ? <PageComponent {...props} pageIsPrivate /> : <PageComponent {...props} />}
    </Layout>
  );
};

export const wrapRootElement = ({ element }) => {
  return (
    <Location>
      {({ location }) =>
        location.pathname.includes('/admin/') ? (
          <NetlifyIdentityProvider>
            <PrivateRoute>{element}</PrivateRoute>
          </NetlifyIdentityProvider>
        ) : (
          element
        )
      }
    </Location>
  );
};

export const onClientEntry = () => {
  const { pathname } = window.location;

  if (pathname.includes('/admin')) {
    window.localStorage.setItem(
      'agencyXPrivateRoutePath',
      JSON.stringify({
        data: pathname
      })
    );
  }
};

export const replaceHydrateFunction = () => (element, container) => {
  const root = ReactDOM.createRoot(container);
  root.render(element);
};
